import { useEffect } from 'react'
import type { Dispatch } from 'react'
import { resolveBotProtectionRuntimeConfig } from '@emporion/ui'
import { fetchPublicRuntimeConfig } from '../../../customerAuthApi'
import type { AuthFlowAction, AuthMode } from './AuthFlow.types'

type UseAuthFlowEffectsInput = {
  mode: AuthMode
  dispatch: Dispatch<AuthFlowAction>
}

export const useAuthFlowEffects = ({ mode, dispatch }: UseAuthFlowEffectsInput) => {
  useEffect(() => {
    dispatch({ type: 'SYNC_MODE', mode })
  }, [dispatch, mode])

  useEffect(() => {
    if (mode !== 'signup') {
      dispatch({
        type: 'BOT_PROTECTION_CONFIG_RESOLVED',
        enabled: false,
        providerId: null,
        clientConfig: null,
      })
      return
    }

    let cancelled = false

    void fetchPublicRuntimeConfig()
      .then((payload) => {
        if (cancelled) return
        const runtimeConfig = resolveBotProtectionRuntimeConfig(payload)
        dispatch({
          type: 'BOT_PROTECTION_CONFIG_RESOLVED',
          enabled:
            runtimeConfig.enabled === true &&
            Boolean(runtimeConfig.providerId) &&
            Boolean(runtimeConfig.client),
          providerId: runtimeConfig.providerId,
          clientConfig: runtimeConfig.client,
        })
      })
      .catch(() => {
        if (cancelled) return
        dispatch({
          type: 'BOT_PROTECTION_CONFIG_RESOLVED',
          enabled: false,
          providerId: null,
          clientConfig: null,
        })
      })

    return () => {
      cancelled = true
    }
  }, [dispatch, mode])
}
